<div class="innerpage-fullwithbanner clearfix">
</div>
<div class="section-margin termnconditionspage">
  <div class="container container-lg">
    <div class="border-div margin-bottom-0">
      <div class="successstep container min-heightcontainer margin-bottom-0" *ngIf="contentType==1">
        <img src="/assets/img/noaccessImage.svg" class="centerimg" />
        <h6 class="no-access-message1 margin-bottom-15">Whoops</h6>
        <h4 class="link-expired-message margin-bottom-20">The Link has been Expired!</h4>
        <h6 class="link-description">The link you received has expired. Please contact your broker.</h6>
        <button class="btn-border btn adduserbtn no-access-page-button">TAKE ME HOME</button>
      </div>
      <div class="row" *ngIf="contentType==0">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 d-felx">
          <div class="be-loader-smal m-auto" style="min-height:200px">
            <div class="m-auto be-loader-inner">
              <div class="circle-loader"></div>
              <p class="margin-t-10">Data Loading...</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
